<template>
  <div class="update" :class="{grid, list, projectHeader, projectCard, linkStyles}">
    <div class="update-title">
      <html-view class="title-text" placeholder="Title" :content="content" :maxLength="maxLength" />
    </div>
  </div>
</template>

<script>
import HtmlView from '@/components/Controls/HTMLView'
import breakpoints from '@/libs/breakpoints'

export default {
  props: {
    content: String,
    list: [],
    grid: Boolean,
    projectHeader: Object,
    projectCard: Object,
    tinyHeader: Object,
    linkStyles: Object
  },
  components: {
    HtmlView
  },
  data: function () {
    return {
    }
  },
  computed: {
    maxLength: function () {
      if (this.projectHeader) {
        return 40
      }

      if (breakpoints.isMobile()) {
        return 45
      }

      if (this.projectCard) {
        return 70
      }

      if (this.list || this.grid) {
        return 74
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.update {
  display: flex;
  flex-direction: column;

  .update-title {
    display: flex;
    align-items: center;
    color: #fff;
    font-weight: bold;
    padding: 2.5rem;
    text-overflow: hidden;
    height:100%;
    overflow: hidden;
    background: $secondary-gradient;

    @include widescreen {
      font-size: 0.95rem;
    }

    @include desktop-only {
      font-weight: 550;
      padding: 1rem 0.8rem;
    }

    @include tablet-only {
      font-weight: 550;
      padding: 1.6rem 2rem;
    }

    @include mobile {
      font-weight: 550;
      padding: 1rem 0.8rem;
      font-size: 0.9rem;

    }

    @include mini-mobile {
      font-size: 0.8rem;
    }
  }

  &.grid, &.list {
    .update-title {
      padding: 1rem;

      @include desktop-only {
        padding: 1.3rem;
      }

      @include tablet-only {
        padding: 0.9rem;
        font-size: 1.4rem;
      }

      @include mobile {
        padding: 0.4rem;
        font-size: 0.75rem;
      }
    }
  }

  &.projectHeader {
    .update-title {
      padding: 1rem;
      padding-left: 1.5rem;
      min-width: 8.5rem;
      min-height: 8.5rem;
      max-width: 8.5rem;
      max-height: 8.5rem;
      font-size: 0.95rem;
      @include mobile {
        padding: 1rem;
        min-width: 6rem;
        min-height: 6rem;
        max-width: 6rem;
        max-height: 6rem;
        font-size: 0.6rem;
        overflow: hidden;
      }
    }
  }

  &.projectCard {
    width: 100%;
    height: 100%;
  }

  &.linkStyles {
    .update-title {
      @include desktop {
        padding: 0.75rem;
        font-size: 0.8rem;
      }
    }
  }
}
</style>

<style lang="scss">
.update {
  .update-title {
    .markdown-span-override {
      &.title-text {
        h1, h2, h3, h4, h5, h6 {
          color: white;
        }

        strong {
          color: white;
        }

        a {
          color: lightgrey;
          &:hover {
            color: white;
          }
        }
      }
    }
  }
}
</style>
